/* Calmour anti-gas advertorial. Shared by every page that uses this block.
   Config arrives on window.CMR from the block: v, l30, l100, mode.
   Source of truth is the repo copy, not the Shopify asset editor. */
(function () {
  var CFG = window.CMR || {};
  if (!CFG.l30 || !CFG.l100) { return; }
  /* say we arrived before anything else, so the inline anim guard stands down */
  window.__cmrAnimOK = 1;

  (function () {
    'use strict';

    var ANTIGAS_VARIANTS = [44858930430004, 44858930462772, 44858930495540];
    var PACKS = {
      44858930462772: { list: CFG.l30, strips: 30 },
      44858930495540: { list: CFG.l100, strips: 100 }
    };
    var FIRST_OFF = 0.10, LATER_OFF = 0.15, MAX_QTY = 10;
    /* 'both' pages let the shopper choose. Anything else, including a garbled
       config, falls back to subscription, i.e. today's live behaviour. */
    var BOTH = CFG.mode === 'both';
    var MONTHS = { '2586247220': 1, '3841261620': 2, '3841294388': 3 };
    /* A full dose is 2 strips. Nobody can do this arithmetic in their head,
       which is exactly why it belongs next to the controls that drive it. */
    function supplyLine() {
      var pack = PACKS[selected('cmr-pack')];
      if (!pack) { return ''; }
      var strips = pack.strips * qty;
      var doses = strips / 2;
      if (!isSub()) { return strips + ' strips is ' + doses + ' full doses.'; }
      var months = MONTHS[selected('cmr-plan')] || 2;
      var perWeek = doses / (months * 4.345);
      var n = perWeek >= 1 ? Math.round(perWeek) : 1;
      var every = months === 1 ? 'every month' : 'every ' + months + ' months';
      return strips + ' strips ' + every
        + ' is about ' + n + (n === 1 ? ' dose' : ' doses') + ' a week.';
    }
    function isSub() { return !BOTH || selected('cmr-mode') === 'sub'; }
    var qty = 1;

    var root = document.querySelector('.cmr');

    /* the block and the stylesheet ship as two files; say so loudly when they disagree.
       only ever visible inside the theme editor, never to a shopper. */
    (function () {
      /* the price lookup fell back to a literal; the page still sells, but say so */
      if (CFG.stale && window.Shopify && window.Shopify.designMode) {
        var w = document.createElement('div');
        w.setAttribute('style', 'position:sticky;top:0;z-index:99;background:#B3261E;color:#fff;'
          + 'font:700 14px/1.4 sans-serif;padding:12px 16px;text-align:center');
        w.textContent = 'Calmour page: the product lookup failed, so prices here are a hardcoded '
          + 'fallback and may be out of date. Check the anti-gas-oral-strips handle and variant IDs.';
        root.insertBefore(w, root.firstChild);
      }
      var BLOCK_V = CFG.v;
      var css = getComputedStyle(root).getPropertyValue('--cmr-css-v').trim();
      if (css === BLOCK_V) { return; }
      if (!(window.Shopify && window.Shopify.designMode)) { return; }
      var b = document.createElement('div');
      b.setAttribute('style', 'position:sticky;top:0;z-index:99;background:#B3261E;color:#fff;'
        + 'font:700 14px/1.4 sans-serif;padding:12px 16px;text-align:center');
      b.textContent = css
        ? 'Calmour page: block is v' + BLOCK_V + ' but calmour-antigas.css is v' + css + '. Re-upload the stylesheet.'
        : 'Calmour page: calmour-antigas.css did not load. Upload it to Assets, or the page will render unstyled.';
      root.insertBefore(b, root.firstChild);
    })();
    if ('IntersectionObserver' in window && document.documentElement.className.indexOf('cmr-anim') < 0) {
      document.documentElement.className += ' cmr-anim';
    }
    if (!root) { return; }

    var els = {
      qty: document.getElementById('cmr-qty'),
      minus: document.getElementById('cmr-minus'),
      plus: document.getElementById('cmr-plus'),
      now: document.getElementById('cmr-now'),
      was: document.getElementById('cmr-was'),
      then: document.getElementById('cmr-then'),
      buy: document.getElementById('cmr-buy'),
      err: document.getElementById('cmr-err')
    };

    function money(c) { return '$' + (c / 100).toFixed(2); }
    /* line price is in cents: divide by strips first, then convert to dollars */
    /* Shopify rounds each line to the cent, so round before multiplying out */
    function discounted(list, off) { return Math.round(list * (1 - off)); }

    function selected(name) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }
    function cadenceLabel() {
      var el = root.querySelector('input[name="cmr-plan"]:checked');
      return el ? el.closest('.c-opt').querySelector('.c-opt-t').textContent.trim() : '';
    }

    var painted = false;
    function flash(el, cls) {
      if (!el || !painted) { return; }
      el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
    }

    function render() {
      var pack = PACKS[selected('cmr-pack')];
      if (!pack) { return; }
      var sub = isSub();
      var firstEach = sub ? discounted(pack.list, FIRST_OFF) : pack.list;
      var laterEach = discounted(pack.list, LATER_OFF);

      els.now.textContent = money(firstEach * qty);
      /* striking the list price against itself is a fictitious reference price */
      els.was.textContent = sub ? money(pack.list * qty) : '';
      els.then.textContent = sub ? money(laterEach * qty) + ' every ' + cadenceLabel() : '';
      if (BOTH) { paintMode(sub); }
      els.qty.textContent = qty;
      els.minus.disabled = qty <= 1;
      els.plus.disabled = qty >= MAX_QTY;


      /* the price is one decision, the recurring term is the other: show both changed */
      sayNow();
      flash(els.now, 'is-upd');
      flash(els.then, 'is-hl');
      painted = true;
    }

    /* everything that is false, or meaningless, for a one-time order */
    function paintMode(sub) {
      var lab = root.querySelector('#cmr-lab-plan');
      var fld = lab && lab.closest ? lab.closest('.c-fld') : null;
      if (fld) { fld.hidden = !sub; }
      var rowThen = els.then && els.then.closest ? els.then.closest('.c-row') : null;
      if (rowThen) { rowThen.hidden = !sub; }
      var nowLab = root.querySelector('#cmr-lab-now');
      if (nowLab) { nowLab.textContent = sub ? 'First delivery' : 'Total'; }
      if (els.buy) { els.buy.textContent = sub ? 'Start my subscription' : 'Add to cart'; }
      var lede = root.querySelector('#cmr-lede');
      if (lede) { lede.textContent = sub ? 'Pick your size. Pick how often.' : 'Pick your size.'; }
      var qtyLab = root.querySelector('#cmr-lab-qty');
      if (qtyLab) { qtyLab.textContent = sub ? 'Packs per delivery' : 'How many packs'; }
      var re = root.querySelector('#cmr-reassure');
      if (re) {
        re.innerHTML = sub
          ? '<b>Change it or cancel anytime, in a couple of clicks.</b><br>Free US shipping on every delivery.'
          : '<b>A single order. No subscription, nothing to cancel.</b><br>Free US shipping.';
      }
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) { throw new Error(url + ' returned ' + r.status); }
        return r.json();
      });
    }

    /* sequential: each /cart/change.js reshuffles the remaining line keys */
    function clearAntigasLines() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('/cart.js ' + r.status); } return r.json(); })
        .then(function (cart) {
          return cart.items
            .filter(function (i) { return ANTIGAS_VARIANTS.indexOf(i.variant_id) !== -1; })
            .reduce(function (chain, i) {
              return chain.then(function () { return post('/cart/change.js', { id: i.key, quantity: 0 }); });
            }, Promise.resolve());
        });
    }

    /* the bigger pack only makes sense on the longer gap: 100 strips every 2 months
       implies about six doses a week. so pair them, but ONLY until the shopper picks
       a cadence themselves, after which their choice is never overwritten. */
    var PACK_100 = '44858930495540', PACK_30 = '44858930462772';
    var PLAN_2MO = '3841261620', PLAN_3MO = '3841294388';
    var cadencePicked = false, pairMsg = '', say = document.getElementById('cmr-say');
    function sayNow() {
      if (!say) { return; }
      var line = supplyLine();
      var showPair = pairMsg && isSub();
      say.textContent = showPair ? pairMsg + ' ' + line : line;
    }

    root.querySelectorAll('input[name="cmr-plan"]').forEach(function (i) {
      i.addEventListener('change', function () {
          cadencePicked = true;
          pairMsg = '';
          render();
        });
    });

    root.querySelectorAll('input[name="cmr-mode"]').forEach(function (i) {
      i.addEventListener('change', render);
    });

    root.querySelectorAll('input[name="cmr-pack"]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (!cadencePicked && isSub()) {
          var want = i.value === PACK_100 ? PLAN_3MO : PLAN_2MO;
          var el = root.querySelector('input[name="cmr-plan"][value="' + want + '"]');
          if (el && !el.checked) {
            el.checked = true;
            pairMsg = 'Delivery set to every ' + cadenceLabel() + ' to suit this pack size.';
          }
        }
        render();
      });
    });

    /* a percentage, not a price, and computed so it can never go stale against the
       list prices. the subscription discount is proportional, so this one figure is
       true for the first delivery and for every one after it. */
    (function () {
      var cheap = document.getElementById('cmr-cheaper');
      if (!cheap) { return; }
      var big = PACKS[PACK_100], small = PACKS[PACK_30];
      var pct = Math.round((1 - (big.list / big.strips) / (small.list / small.strips)) * 100);
      cheap.textContent = pct + '% less per strip';
    })();
    els.minus.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    els.plus.addEventListener('click', function () { if (qty < MAX_QTY) { qty++; render(); } });

    var busy = false;
    els.buy.addEventListener('click', function () {
      if (busy) { return; }
      busy = true;
      var variantId = parseInt(selected('cmr-pack'), 10);
      var planId = parseInt(selected('cmr-plan'), 10);
      var wantSub = isSub();
      var sendQty = qty;
      var original = els.buy.textContent;

      els.buy.disabled = true;
      els.buy.textContent = 'Adding…';
      els.err.style.display = 'none';

      clearAntigasLines()
        .then(function () {
          var line = { id: variantId, quantity: sendQty };
          /* omit the key entirely on one-time; do not send null, which is untested */
          if (wantSub) { line.selling_plan = planId; }
          return post('/cart/add.js', { items: [line] });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) {
          console.error('[calmour subscription]', e);
          busy = false;
          els.buy.disabled = false;
          els.buy.textContent = original;
          els.err.style.display = 'block';
        });
    });

    

    /* ---- review row: keeps auto-scrolling; the clones are hidden from screen readers ---- */
    (function () {
      var track = document.getElementById('cmr-track');
      if (!track) { return; }
      Array.prototype.slice.call(track.children).forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
    })();

    /* ---- FAQ: animate the height so the answer does not teleport the page ---- */
    root.querySelectorAll('.c-faq details').forEach(function (d) {
      var body = d.querySelector('div'), sum = d.querySelector('summary'), run = null, PAD = 22;
      if (!body || !body.animate) { return; }
      sum.addEventListener('click', function (e) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
        e.preventDefault();
        if (run) { run.cancel(); run = null; }
        var wasOpen = d.open;
        if (!wasOpen) { d.open = true; }
        var full = body.scrollHeight;
        run = body.animate([
          { height: (wasOpen ? full : 0) + 'px', paddingBottom: (wasOpen ? PAD : 0) + 'px', opacity: wasOpen ? 1 : 0 },
          { height: (wasOpen ? 0 : full) + 'px', paddingBottom: (wasOpen ? 0 : PAD) + 'px', opacity: wasOpen ? 0 : 1 }
        ], { duration: wasOpen ? 220 : 280, easing: 'cubic-bezier(.22,1,.36,1)' });
        run.onfinish = function () { if (wasOpen) { d.open = false; } run = null; };
      });
    });

    /* ---- headline swap for ad message match: /pages/...?h=purse ---- */
    var HOOKS = {
      purse: {
        h1: 'The bloating relief<br>you actually have on you.',
        sub: 'A Calmour strip dissolves on your tongue in 30 seconds. No pill. No water. Flat enough to carry everywhere, so it is there the moment you need it.'
      },
      restaurant: {
        h1: 'Finish the meal.<br>Skip the aftermath.',
        sub: 'A Calmour strip dissolves on your tongue in 30 seconds. Keep one in your wallet and the meal stops being a decision.'
      },
      travel: {
        h1: 'Bloating at 30,000 feet,<br>and nowhere to go.',
        sub: 'A Calmour strip dissolves on your tongue in 30 seconds. No liquid, so it goes through security in your wallet.'
      }
    };
    try {
      var hook = HOOKS[new URLSearchParams(window.location.search).get('h')];
      if (hook) {
        document.getElementById('cmr-h1').innerHTML = hook.h1;
        document.getElementById('cmr-sub').textContent = hook.sub;
      }
    } catch (e) { /* older browsers keep the default headline */ }

    /* ---- one reveal on the page ---- */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var watch = function (sel, bottom) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { threshold: 0, rootMargin: '0px 0px ' + bottom + ' 0px' });
        root.querySelectorAll(sel).forEach(function (el) { io.observe(el); });
      };
      watch('.c-reveal:not(.c-reveal--early)', '-18%');
      watch('.c-reveal--early', '-10%');
      window.__cmrAnimOK = 1;
    } else {
      root.querySelectorAll('.c-reveal').forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---- step loops: load and play only once they are actually on screen ---- */
    (function () {
      var vids = root.querySelectorAll('video.c-vid');
      if (!vids.length) { return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      var io3 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            v.preload = 'auto';
            var pr = v.play();
            if (pr && pr.catch) {
              pr.catch(function (err) { console.warn('[cmr] step loop did not play:', v.currentSrc || '(no source)', err && err.name); });
            }
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io3.observe(v); });
    })();

    /* ---- review row on mobile: drifts on its own until you touch it ---- */
    (function () {
      var m = root.querySelector('.c-marquee'), t = document.getElementById('cmr-track');
      if (!m || !t) { return; }
      var phone = window.matchMedia('(max-width:749px)');
      var slow = window.matchMedia('(prefers-reduced-motion: reduce)');
      var raf = null, taken = false;
      function step() {
        if (taken) { return; }
        var half = t.scrollWidth / 2;
        if (m.scrollLeft >= half) { m.scrollLeft -= half; }
        m.scrollLeft += 0.55;
        raf = requestAnimationFrame(step);
      }
      function hand() { taken = true; if (raf) { cancelAnimationFrame(raf); raf = null; } }
      function start() {
        if (!phone.matches || slow.matches || taken || raf) { return; }
        raf = requestAnimationFrame(step);
      }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (e) {
        m.addEventListener(e, hand, { passive: true });
      });
      /* photos stay as placeholders until the row is nearly in view; the
         clones carry data-src too, so this one pass covers both copies. */
      function fill() {
        var imgs = m.querySelectorAll('img[data-src]');
        for (var i = 0; i < imgs.length; i++) {
          imgs[i].src = imgs[i].getAttribute('data-src');
          imgs[i].removeAttribute('data-src');
        }
      }
      if (phone.addEventListener) { phone.addEventListener('change', start); }
      /* the drift used to run from page load for a row ~9,000px down. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es, obs) {
          if (!es[0].isIntersecting) { return; }
          obs.disconnect();
          fill();
          start();
        }, { rootMargin: '600px 0px' }).observe(m);
      } else {
        fill();
        start();
      }
    })();

    /* ---- sticky mobile CTA: appears once the hero CTA is gone, hides over the offer ---- */
    (function () {
      var bar = document.getElementById('cmr-sticky');
      var hero = root.querySelector('.c-hero-cta');
      var offer = document.getElementById('cmr-offer');
      if (!bar || !hero || !offer || !('IntersectionObserver' in window)) { return; }
      var pastHero = false, atOffer = false;
      function sync() {
        var show = pastHero && !atOffer;
        bar.classList.toggle('is-up', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; sync(); },
        { threshold: 0 }).observe(hero);
      new IntersectionObserver(function (e) { atOffer = e[0].isIntersecting; sync(); },
        { threshold: 0, rootMargin: '0px 0px -30% 0px' }).observe(offer);
    })();

    render();
  })();
})();
